// src/modules/reports/help/constants/help-anchors.ts

export const REPORTS_HELP_DASHBOARD = {
  COVERAGE: 'coverage',
  RISK: 'risk-replenishment',
  PERFORMANCE: 'performance-products',
  DELIVERY: 'deliveries',
  REGIONAL_COVERAGE: 'regional-coverage',
} as const;

export type ReportsHelpDashboard = (typeof REPORTS_HELP_DASHBOARD)[keyof typeof REPORTS_HELP_DASHBOARD];

export const REPORTS_HELP = {
  COVERAGE: {
    SUMMARY: 'coverage-summary',
    BUCKET_DONUT: 'coverage-buckets',
    NET_CONSUMPTION: 'net-consumption',
    BY_SUPPLIER: 'coverage-by-supplier',
    BY_CATEGORY: 'coverage-by-category',
    TURNOVER: 'turnover',
    LIST: 'coverage-list',
  },
  RISK: {
    SUMMARY: 'risk-summary',
    FLAG_DONUT: 'risk-flags',
    RUPTURE_SUMMARY: 'rupture-summary',
    RUPTURE_TIMELINE: 'rupture-timeline',
    BY_SUPPLIER: 'risk-by-supplier',
    LIST_TABS: 'risk-lists',
  },
  PERFORMANCE: {
    SUMMARY: 'score-summary',
    SCORE_DISTRIBUTION: 'score-distribution',
    BY_CATEGORY: 'score-by-category',
    TOP_SELLERS: 'top-sellers',
  },
  DELIVERY: {
    SUMMARY: 'delivery-summary',
    HISTOGRAM: 'delivery-histogram',
    DELAY_BUCKETS: 'delivery-delay-buckets',
    BY_DPA: 'delivery-by-dpa',
    DC_RANKING: 'delivery-dc-ranking',
  },
  REGIONAL_COVERAGE: {
    CONCEPTS: 'rc-concepts',
    SUMMARY: 'rc-summary',
    REGION_CARDS: 'rc-region-cards',
    GAP_MATRIX: 'rc-gap-matrix',
    SUPPLIERS: 'rc-suppliers',
    CATEGORIES: 'rc-categories',
    CRITICAL: 'rc-critical',
    GAP_DETAIL: 'rc-gap-detail',
  },
} as const;

const DASHBOARD_PARENT_PATH: Record<ReportsHelpDashboard, string> = {
  coverage: '/reports/inventory',
  'risk-replenishment': '/reports/inventory',
  'performance-products': '/reports/inventory',
  deliveries: '/reports/sales',
  'regional-coverage': '/reports/inventory',
};

export function reportsDashboardPath (dashboard: ReportsHelpDashboard): string {
  return `${DASHBOARD_PARENT_PATH[dashboard]}/${dashboard}`;
}

export function reportsHelpHref (dashboard: ReportsHelpDashboard, anchorId: string): string {
  return `${reportsDashboardPath(dashboard)}/help#${anchorId}`;
}

// ---------------------------------------------------------------------------
// Legacy aliases — kept so the ~17 existing `INVENTORY_HELP*` imports compile
// unchanged. New code should import the REPORTS_HELP_* names directly.
// ---------------------------------------------------------------------------
export const INVENTORY_HELP_DASHBOARD = REPORTS_HELP_DASHBOARD;
export type InventoryHelpDashboard = ReportsHelpDashboard;
export const INVENTORY_HELP = REPORTS_HELP;
export const inventoryHelpHref = reportsHelpHref;
